<!-- eslint-disable vue/no-v-html -->
<template>
  <div
    :style="`background: ${element.style.backgroundColor};color:${element.style.color}`"
  >
    <div
      class="LTable"
      :style="{
        borderTopColor: element.style.lineColor,
        borderLeftColor: element.style.lineColor,
        borderTopWidth: element.style.frameWeight + 'px',
        borderLeftWidth: element.style.frameWeight + 'px'
      }"
    >
      <div
        v-for="(item, index) in element.tableData.dataList"
        :key="index"
        class="tr"
        :style="{
          fontSize:
            (index === 0
              ? ((element.style.tableHeadFontSize * scale) / 100).toFixed(0)
              : ((element.style.tableBodyFontSize * scale) / 100).toFixed(0)) +
            'px',
          height: ((item.trHeight * scale) / 100).toFixed(0) + 'px'
        }"
      >
        <div
          v-for="(tdItem, tdIndex) in item.children"
          :key="tdIndex"
          :style="{
            borderBottomColor: element.style.lineColor,
            borderRightColor: element.style.lineColor,
            borderBottomWidth: element.style.frameWeight + 'px',
            borderRightWidth: element.style.frameWeight + 'px',
            width: ((tdItem.tdWidth * scale) / 100).toFixed(0) + 'px'
          }"
          class="td"
        >
          {{
            element.tableData.tableTextType === '1'
              ? tdItem.value
              : tdItem.value.realValue
          }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import request from '@/utils/request'
import OnEvent from '../common/OnEvent.vue'
export default {
  extends: OnEvent,
  props: {
    propValue: {
      type: String,
      required: true,
      default: ''
    },
    request: {
      type: Object,
      default: () => {}
    },
    element: {
      type: Object,
      default: () => {}
    },
    linkage: {
      type: Object,
      default: () => {}
    },
    scale: {
      type: Number,
      default: 100
    },
    noEdit: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      canEdit: false,
      ctrlKey: 17,
      isCtrlDown: false,
      cancelRequest: null,
      list: []
    }
  },
  computed: {
    ...mapState({
      editMode: (state) => state.compose.editMode,
      curComponent: (state) => state.compose.curComponent,
      projectItem: (state) => state.user.projectItem
    })
  },
  created() {
    console.log('element', this.element)
    this.updateData()
    // 注意，修改时接口属性时不会发数据，在预览时才会发
    // 如果要在修改接口属性的同时发请求，需要 watch 一下 request 的属性
    if (this.request) {
      // 第二个参数是要修改数据的父对象，第三个参数是修改数据的 key，第四个数据修改数据的类型
      this.cancelRequest = request(
        this.request,
        this.element,
        'propValue',
        'string'
      )
    }
  },
  beforeDestroy() {
    // 组件销毁时取消请求
    this.request && this.cancelRequest()
  },
  methods: {
    updateData() {}
  }
}
</script>

<style lang="scss" scoped>
.LTable {
  border-top-style: solid;
  border-left-style: solid;
  .tr {
    height: 40px;
    display: flex;
    // border-left-style: solid;
    .td {
      border-right-style: solid;
      border-bottom-style: solid;
      width: 200px;
      height: 100%;
      display: flex;
      align-items: center;
      padding: 0 10px;
      flex-shrink: 0;
    }
  }
}
</style>
